import { SITUAR_IMAGEN } from "../constants/actions-types";


const defaultSituar = {
	situar:"",
	posicion:"",
};

function situarReducer(state=defaultSituar,action){
	if(action.type === SITUAR_IMAGEN){
		let newState = {...state};
		newState[action.datos.tipo] = action.datos.valor;
		return newState;
	}
	return state;
}

export default situarReducer;